export default function Spinner({ customClass = 'h-8 w-8' }) {
  return (
    <div className="flex justify-center">
      <div
        className={`animate-spin rounded-full ${customClass} border-b-2 border-blue-500`}
      ></div>
    </div>
  );
}
